import React from "react";
import ServiceCenterProps from "./ServiceCenterProps";
import WazeImage from "../../assets/images/waze_icon.png";
import GoogleMaps from "../../assets/images/googlemaps.png"; 

import "./ServiceCenter.scss";

const ServiceCenter = (props: ServiceCenterProps) => {
  const [service, setService] = React.useState(props);

  React.useEffect(() => {
    setService(props);
  }, [props]);

  const openInNewTab = (url: string) => {
    const newWindow = window.open(url, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
  };

  return (
    <div className="service-center-line">
      
      <div className="city"><h3>{service.city}</h3> </div>
     
      {/* <div className="service-center-images"> */}
       
       
        <div className="line">
        <div className="address">
<div className="waze-google"> 


<div className="google-maps-img">
  <button
  style={{position:"relative", top:"1px"}}
    className="service-center-button"
    onClick={() => {
      openInNewTab(service.googleLink);
    }}
    title="מעבר לאתר חיצוני"
  >
    <img src={GoogleMaps} alt="google" />
  </button>
</div>

<div className="waze-img">
  <button
    className="service-center-button"
    onClick={() => {
      openInNewTab(service.wazeLink);
    }}
    title="מעבר לאתר חיצוני"
  >
    <img src={WazeImage} alt="waze" />
  </button>
</div>

</div>
  {service.detail}
  </div>
        </div>       
      {/* </div> */}
    </div>
  );
};

export default ServiceCenter;
